@if (data && institutionId >= 0) {
  <div
    id="submodule-data"
    class="cw-module-card">
    <!-- Header -->
    <div class="cw-flex-row">
      <!-- Debug - START -->
      <!--{{spy.className}}
      <p *ngIf="!institutionsDataForm.valid">Form is invalid!</p>
      <pre>{{ institutionsDataForm.value | json }}</pre>
      <pre>{{ data | json}}</pre>-->
      <!-- Debug - END -->

      @if (!institutionsService.isShadow) {
        <h2>{{ 'GENERAL.COREDATA' | translate }}</h2>
      }
      @if (institutionsService.isShadow) {
        <h2>Änderungsanfrage</h2>
      }

      @if (data && !loading && !hideToolbar) {
        <phscw-toolbar
          componentIdentifier="institutions-data"
          [componentConnection]="$any(this)"
          [buttonEditmode]="(allowEditCombined && !notEmptyLocal(data.onekey_number)) || forceNormalEditMode"
          [buttonShadowEditmode]="allowEditShadowCombined && notEmptyLocal(data.onekey_number)"
          [buttonCancel]="true"
          [buttonGoogleMaps]="institutionId > 0 && !institutionsService.isShadow"
          [buttonParkopedia]="institutionId > 0 && !institutionsService.isShadow"
          [buttonSearchDuplicate]="allowMergeEntities && !institutionsService.isShadow"
            [buttonSearchDuplicateParameter]="{
                disabled:
                    data?.name1?.length <= 0 &&
                    data?.name2?.length <= 0 &&
                    data?.city?.length <= 0 &&
                    data?.street?.length <= 0
            }"
          [buttonRemoteEdetailerInvite]="institutionId > 0 && showEdetailerLinks"
          [buttonRemoteEdetailerStart]="institutionId > 0 && showEdetailerLinks"
          [buttonRemoteEdetailerParameter]="disableEdetailerLinks"
          [buttonChat]="institutionsEnableAiChat && institutionId > 0"
          [buttonChatInstitutionID]="institutionId">
        </phscw-toolbar>
      }
    </div>
    @if ((data.id == 0 && editMode) || data.id > 0) {
      <div class="cw-flex-row">
        <phscw-clearing-duplicates-panel
          gridId="institutionsDuplicateList"
          [entity]="data"
        backendController="ClearingDuplicates/findPossibleDuplicates"></phscw-clearing-duplicates-panel>
      </div>
    }

    <div [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></div>

    @if (data && !loading) {
      <form
        #institutionsDataForm="ngForm"
        (ngSubmit)="clickSubmit()"
        (keydown.enter)="$event.preventDefault()"
        #spy>
        <!-- Content -->
        <div class="cw-submodules">
          <div class="cw-submodule">
            <h3>{{ 'GENERAL.INSTITUTION' | translate }}</h3>
            <div class="cw-horizontalline"></div>
            @if (datafieldsConfiguration?.id.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.INSTITUTIONID' | translate }}"
                [required]="datafieldsConfiguration.id.required"
                [disabled]="datafieldsConfiguration.id.disabled"
                name="id"
                inputId="id"
                [(ngModel)]="data.id">
              </phscw-input-text>
            }
            @if (datafieldsConfiguration?.erp_number.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.ERP' | translate }}"
                [required]="datafieldsConfiguration.erp_number.required"
                name="erp_number"
                inputId="erp_number"
                [(ngModel)]="data.erp_number"
                        [disabled]="
                            (data.id > 0 && allowEditInstitutionErpNumber == false) ||
                            (data.id == 0 && disableNewInstitutionErpNumber)
                                ? true
                                : false
                        ">
              </phscw-input-text>
            }
            @if (datafieldsConfiguration?.permament_establishment_number?.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'MODULES.INSTITUTIONS.DATA.PERMAMENTESTABLISHMENTNUMBER' | translate }}"
                [required]="datafieldsConfiguration?.permament_establishment_number?.required"
                name="permament_establishment_number"
                inputId="permament_establishment_number"
                [(ngModel)]="data.permament_establishment_number"
                        [disabled]="
                            datafieldsConfiguration?.permament_establishment_number?.disabled
                        "></phscw-input-text>
            }
            @if (datafieldsConfiguration?.health_insurance_association?.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'MODULES.INSTITUTIONS.DATA.HEALTHINSURANCEASSOCIATION' | translate }}"
                [required]="datafieldsConfiguration?.health_insurance_association?.required"
                name="health_insurance_association"
                inputId="health_insurance_association"
                [(ngModel)]="data.health_insurance_association"
              [disabled]="datafieldsConfiguration?.health_insurance_association?.disabled"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.onekey_number.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.ONEKEY' | translate }}"
                [required]="datafieldsConfiguration.onekey_number.required"
                [disabled]="datafieldsConfiguration.onekey_number.disabled"
                name="onekey_number"
                inputId="onekey_number"
              [(ngModel)]="data.onekey_number"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.bga_number.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.BGANUMBER' | translate }}"
                [required]="datafieldsConfiguration.bga_number.required"
                [disabled]="datafieldsConfiguration.bga_number.disabled"
                name="bga_number"
                inputId="bga_number"
              [(ngModel)]="data.bga_number"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.external_customer_id1.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.EXTERNALCUSTOMERNUMBER1' | translate }}"
                [required]="datafieldsConfiguration.external_customer_id1.required"
                [disabled]="datafieldsConfiguration.external_customer_id1.disabled"
                name="external_customer_id1"
                inputId="external_customer_id1"
              [(ngModel)]="data.external_customer_id1"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.external_customer_id2.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.EXTERNALCUSTOMERNUMBER2' | translate }}"
                [required]="datafieldsConfiguration.external_customer_id2.required"
                [disabled]="datafieldsConfiguration.external_customer_id2.disabled"
                name="external_customer_id2"
                inputId="external_customer_id2"
              [(ngModel)]="data.external_customer_id2"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.name1.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.NAME' | translate }}"
                [required]="datafieldsConfiguration.name1.required"
                [disabled]="datafieldsConfiguration.name1.disabled"
                name="name1"
                inputId="name1"
                [(ngModel)]="data.name1"
                (focusout)="initiateDuplicatesCheck()"
              [maxlength]="institutionsSchema?.name1?.length"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.name2.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'MODULES.INSTITUTIONS.DATA.ADDITIONAL1' | translate }}"
                [required]="datafieldsConfiguration.name2.required"
                [disabled]="datafieldsConfiguration.name2.disabled"
                name="name2"
                inputId="name2"
                [(ngModel)]="data.name2"
                (focusout)="initiateDuplicatesCheck()"
              [maxlength]="institutionsSchema?.name2?.length"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.name3.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'MODULES.INSTITUTIONS.DATA.ADDITIONAL2' | translate }}"
                [required]="datafieldsConfiguration.name3.required"
                [disabled]="datafieldsConfiguration.name3.disabled"
                name="name3"
                inputId="name3"
              [(ngModel)]="data.name3"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.name4.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'MODULES.INSTITUTIONS.DATA.ADDITIONAL3' | translate }}"
                [required]="datafieldsConfiguration.name4.required"
                [disabled]="datafieldsConfiguration.name4.disabled"
                name="name4"
                inputId="name4"
              [(ngModel)]="data.name4"></phscw-input-text>
            }
            <!-- Selectbox - Einbindende Komponente hat keine genaue Kenntnis über Optionen, es wird "listentries" verwendet -->
            @if (datafieldsConfiguration?.type1.visible) {
              <phscw-input-select
                label="{{ 'MODULES.INSTITUTIONS.DATA.TYPE1' | translate }}"
                [editMode]="editMode"
                name="type1"
                inputId="type1"
                [required]="datafieldsConfiguration.type1.required"
                [disabled]="datafieldsConfiguration.type1.disabled"
                [selectData]="institutionType1Options"
                [(ngModel)]="data.type1"
                [isShadow]="institutionsService.isShadow"
                [shadowEditIgnoreList]="shadowEditIgnoreList"
                (change)="getInputSelectOptions()">
              </phscw-input-select>
            }
            @if (datafieldsConfiguration?.type2.visible) {
              <phscw-input-select
                label="{{ 'MODULES.INSTITUTIONS.DATA.TYPE2' | translate }}"
                [editMode]="editMode"
                name="type2"
                inputId="type2"
                [required]="datafieldsConfiguration.type2.required"
                [disabled]="datafieldsConfiguration.type2.disabled"
                [selectData]="institutionType2Options"
              [(ngModel)]="data.type2"></phscw-input-select>
            }
            <!-- Eltern-Einrichtungszuordnungen -->
            @if (
              institutionId > 0 &&
              !institutionsService.isShadow &&
              datafieldsConfiguration?.parent.visible
              ) {
              <phscw-input-autocomplete
                label="{{ 'MODULES.INSTITUTIONS.DATA.PARENT' | translate }}"
                [editMode]="editMode"
                inputId="parent"
                [required]="datafieldsConfiguration.parent.required"
                [disabled]="datafieldsConfiguration.parent.disabled"
                name="parent"
                backendLink="Institutions/searchInstitutionsForAutoComplete"
                [showDeleteButton]="true"
                        [myValue]="
                            (data.parent | isUndefined) || (data.parent[0] | isUndefined) ? '' : data.parent[0].label
                        "
                [returnLabel]="true"
                [disabled]="!allowMoveInstitution"
                (optionSelected)="updateParentInstitutionData($event)"
                (deleteClicked)="deleteParentInstitutionData()">
              </phscw-input-autocomplete>
            }
          </div>
          <div class="cw-submodule">
            <h3>{{ 'GENERAL.ADDRESS' | translate }}</h3>
            <div class="cw-horizontalline"></div>
            @if (datafieldsConfiguration?.street.visible) {
              <phscw-input-text
                [editMode]="editMode"
                name="street"
                inputId="street"
                label="{{ 'GENERAL.STREET' | translate }}"
                [required]="datafieldsConfiguration.street.required"
                [disabled]="datafieldsConfiguration.street.disabled"
                [(ngModel)]="data.street"
              (focusout)="initiateDuplicatesCheck()"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.street_number_from.visible) {
              <phscw-input-text
                [editMode]="editMode"
                name="street_number_from"
                inputId="street_number_from"
                label="{{ 'MODULES.INSTITUTIONS.DATA.STREETNUMFROM' | translate }}"
                [required]="datafieldsConfiguration.street_number_from.required"
                [disabled]="datafieldsConfiguration.street_number_from.disabled"
              [(ngModel)]="data.street_number_from"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.street_number_to.visible) {
              <phscw-input-text
                [editMode]="editMode"
                name="street_number_to"
                inputId="street_number_to"
                label="{{ 'MODULES.INSTITUTIONS.DATA.STREETNUMTO' | translate }}"
                [required]="datafieldsConfiguration.street_number_to.required"
                [disabled]="datafieldsConfiguration.street_number_to.disabled"
                [(ngModel)]="data.street_number_to">
              </phscw-input-text>
            }
            @if (
              datafieldsConfiguration?.zipcode.visible &&
              datafieldsConfiguration?.city.visible &&
              combinedZipcodeCityInputEnabled &&
              editMode
              ) {
              <phscw-input-autocomplete
                [editMode]="editMode"
                name="zipcode"
                inputId="zipcode"
                label="{{ 'GENERAL.ZIPCODECITY' | translate }}"
                backendLink="InstitutionsData/getCities"
                [showDeleteButton]="false"
                [returnLabel]="true"
                [myValue]="getZipcodeCityCombinationData()"
                [required]="datafieldsConfiguration.zipcode.required"
                [disabled]="datafieldsConfiguration.zipcode.disabled"
                (optionSelected)="setZipcodeCityCombinationData($event)">
              </phscw-input-autocomplete>
            }
            <!-- zum Speichern der Eingabe in autocomplete -->
            @if (
              datafieldsConfiguration?.zipcode.visible &&
              datafieldsConfiguration?.city.visible &&
              combinedZipcodeCityInputEnabled &&
              editMode
              ) {
              <input
                type="hidden"
                name="zipcode"
                [required]="datafieldsConfiguration.zipcode.required"
                [(ngModel)]="data.zipcode" />
            }
            @if (
              datafieldsConfiguration?.zipcode.visible &&
              datafieldsConfiguration?.city.visible &&
              combinedZipcodeCityInputEnabled &&
              editMode
              ) {
              <input
                type="hidden"
                name="city"
                [required]="datafieldsConfiguration.city.required"
                [(ngModel)]="data.city" />
            }
            @if (
              datafieldsConfiguration?.zipcode.visible &&
              ((combinedZipcodeCityInputEnabled && !editMode) || !combinedZipcodeCityInputEnabled)
              ) {
              <phscw-input-text
                [editMode]="editMode"
                name="zipcode"
                inputId="zipcode"
                label="{{ 'GENERAL.ZIPCODE' | translate }}"
                [required]="datafieldsConfiguration.zipcode.required"
                [disabled]="datafieldsConfiguration.zipcode.disabled"
                #zipcode="ngModel"
                [error]="zipcode.errors"
                [(ngModel)]="data.zipcode"
              [maxlength]="institutionsSchema.zipcode.length"></phscw-input-text>
            }
            @if (
              datafieldsConfiguration?.city.visible &&
              ((combinedZipcodeCityInputEnabled && !editMode) || !combinedZipcodeCityInputEnabled)
              ) {
              <phscw-input-text
                [editMode]="editMode"
                name="city"
                inputId="city"
                label="{{ 'GENERAL.CITY' | translate }}"
                [required]="datafieldsConfiguration.city.required"
                [disabled]="datafieldsConfiguration.city.disabled"
                [(ngModel)]="data.city"
                (focusout)="initiateDuplicatesCheck()"
              [maxlength]="institutionsSchema.city.length"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.district.visible) {
              <phscw-input-text
                [editMode]="editMode"
                name="district"
                inputId="district"
                label="{{ 'GENERAL.DISTRICT' | translate }}"
                [required]="datafieldsConfiguration.district.required"
                [disabled]="datafieldsConfiguration.district.disabled"
                [(ngModel)]="data.district">
              </phscw-input-text>
            }
            <!-- Bundesland -->
            <!-- Achtung! Es muss zwei Mal auf "county" zugegriffen werden, damit das Bundesland korrekt angezeigt wird -->
            @if (datafieldsConfiguration?.county.visible) {
              <phscw-input-select
                [editMode]="editMode"
                name="county"
                inputId="county"
                label="{{ 'GENERAL.COUNTY' | translate }}"
                [required]="datafieldsConfiguration.county.required"
                [disabled]="datafieldsConfiguration.county.disabled"
                [(ngModel)]="$any(data.county).county"
              listentries="county"></phscw-input-select>
            }
            <!-- Land -->
            <!-- Auswahl zwischen select und text über config, standard ist text-->
            @if (
              datafieldsConfiguration?.country.visible &&
              (datafieldsConfiguration.country.cwInputType === 'text' ||
              !datafieldsConfiguration.country.cwInputType)
              ) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.COUNTRY' | translate }}"
                name="country"
                inputId="country"
                [required]="datafieldsConfiguration.country.required"
                [disabled]="datafieldsConfiguration.country.disabled"
                [(ngModel)]="data.country">
              </phscw-input-text>
            }
            @if (
              datafieldsConfiguration?.country.visible &&
              datafieldsConfiguration.country.cwInputType === 'select'
              ) {
              <phscw-input-select
                [editMode]="editMode"
                label="{{ 'GENERAL.COUNTRY' | translate }}"
                name="country"
                inputId="country"
                listentries="country"
                [required]="datafieldsConfiguration.country.required"
                [disabled]="datafieldsConfiguration.country.disabled"
                [(ngModel)]="data.country">
              </phscw-input-select>
            }
          </div>
          <div class="cw-submodule">
            <h3>{{ 'GENERAL.COMMUNICATION' | translate }}</h3>
            <div class="cw-horizontalline"></div>
            @if (datafieldsConfiguration?.phone1.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.PHONE' | translate }}"
                [required]="datafieldsConfiguration.phone1.required"
                [disabled]="datafieldsConfiguration.phone1.disabled"
                name="phone1"
                inputId="phone1"
                valueDecorator="phone"
                [(ngModel)]="data.phone1"
                #phone1="ngModel"
                [error]="phone1.errors">
              </phscw-input-text>
            }
            @if (datafieldsConfiguration?.phone2.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'MODULES.INSTITUTIONS.DATA.PHONE2' | translate }}"
                [required]="datafieldsConfiguration.phone2.required"
                [disabled]="datafieldsConfiguration.phone2.disabled"
                name="phone2"
                inputId="phone2"
                valueDecorator="phone"
                [(ngModel)]="data.phone2"
                #phone2="ngModel"
                [error]="phone2.errors">
              </phscw-input-text>
            }
            @if (datafieldsConfiguration?.phone3.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'MODULES.INSTITUTIONS.DATA.PHONE3' | translate }}"
                [required]="datafieldsConfiguration.phone3.required"
                [disabled]="datafieldsConfiguration.phone3.disabled"
                name="phone3"
                inputId="phone3"
                valueDecorator="phone"
                [(ngModel)]="data.phone3"
                #phone3="ngModel"
                [error]="phone3.errors">
              </phscw-input-text>
            }
            @if (datafieldsConfiguration?.fax.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.FAX' | translate }}"
                [required]="datafieldsConfiguration.fax.required"
                [disabled]="datafieldsConfiguration.fax.disabled"
                name="fax"
                inputId="fax"
                [(ngModel)]="data.fax"
                #fax="ngModel"
              [error]="fax.errors"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.mail.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.MAIL' | translate }}"
                [required]="datafieldsConfiguration.mail.required"
                [disabled]="datafieldsConfiguration.mail.disabled"
                name="mail"
                inputId="mail"
                valueDecorator="mail"
                inputType="email"
                [(ngModel)]="data.mail"
                #mail="ngModel"
              [error]="mail.errors"></phscw-input-text>
            }
            @if (datafieldsConfiguration?.internet.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'MODULES.INSTITUTIONS.DATA.INTERNET' | translate }}"
                [required]="datafieldsConfiguration.internet.required"
                [disabled]="datafieldsConfiguration.internet.disabled"
                name="internet"
                inputId="internet"
                valueDecorator="url"
                inputType="url"
                [(ngModel)]="data.internet"
                #url="ngModel"
              [error]="url.errors"></phscw-input-text>
            }
            @if (institutionsService.isShadow) {
              <phscw-input-text
                [editMode]="editMode"
                label="Änderungsgrund"
                [required]="true"
                name="validation_comment"
                inputId="validation_comment"
                [maxlength]="230"
                [(ngModel)]="$any(data).validation_comment"
              #url="ngModel"></phscw-input-text>
            }
          </div>
          @if (datafieldsConfiguration?.supplementary_numbers.visible && !institutionsService.isShadow) {
            <div
              class="cw-submodule">
              <h3>{{ 'MODULES.INSTITUTIONS.DATA.NUMBERS' | translate }}</h3>
              <div class="cw-horizontalline"></div>
              @if (datafieldsConfiguration?.supplementary_numbers.visible) {
                <phscw-institutions-data-supplementary-numbers
                  [editMode]="editMode"
                  label="{{ 'MODULES.INSTITUTIONS.DATA.SUPPLEMENTARYNUMBERS.LABEL' | translate }}"
                  name="supplementary_numbers"
                  inputId="supplementary_numbers"
                  formModelGroup="supplementary_numbers"
                  [institutionId]="institutionId"
                  [data]="data.supplementary_numbers">
                </phscw-institutions-data-supplementary-numbers>
              }
            </div>
          }
          @if (!institutionsService.isShadow) {
            <div
              class="cw-submodule"
              >
              <h3>{{ 'GENERAL.REGIONASSIGNMENT' | translate }}</h3>
              <div class="cw-horizontalline"></div>
              <div class="cw-region-assignments">
                @for (region of data.regions; track region) {
                  <phscw-overlay-trigger-link
                    componentName="OverlayInfoEmployee"
                    backendController="Regions"
                    backendMethod="getEmployeeByRegion"
                    [entityId]="region.id"
                  [linkLabel]="region.templateLabel"></phscw-overlay-trigger-link>
                  <input
                    type="hidden"
                    name="region_id"
                    [(ngModel)]="region.id" />
                }
                @if (data.segment_id1) {
                  <p>
                    <span>{{ $any(data).segment_name_1 }}</span>
                  </p>
                }
                @if (data.segment_id2) {
                  <p>
                    <span>{{ data.segment_name_2 }}</span>
                  </p>
                }
              </div>
              @if (editMode && allowManualRegionAllocations) {
                <div
                  class="cw-horizontalline"
                ></div>
              }
              <!-- Sonder-Gebietszuordnungen -->
              @if (editMode && allowManualRegionAllocations) {
                <phscw-input-multiple-autocomplete
                  [editMode]="editMode"
                  label="{{ 'MODULES.INSTITUTIONS.DATA.MANUALREGIONS' | translate }}"
                  name="manualregions"
                  inputId="manualregions"
                  [hideEmpty]="true"
                  [hideChecked]="true"
                  [displayRadioButton]="false"
                  [allowSelection]="true"
                  [allowAddition]="true"
                  formModelGroup="manualregions"
                  backendLink="Regions/searchRegionsForAutoComplete"
                  [data]="data.manualregions"
                  [optionalRestrictions]="noDeletedRegionsRestriction"
                  (elementRemoved)="resetRegionData($event)">
                </phscw-input-multiple-autocomplete>
              }
            </div>
          }
        </div>
        <!-- Timestamps -->
        @if (data.id > 0 && !institutionsService.isShadow) {
          <div class="cw-horizontalline"></div>
          @if (timestampsVisible) {
            <div>
              @if (datafieldsConfiguration?.create.visible) {
                <phscw-output-timestamp
                  class="cw-flex-row"
                  label="{{ 'GENERAL.CREATION' | translate }}"
                  [timestamp]="data.create_date"
                additional="{{ data.create_user }}"></phscw-output-timestamp>
              }
              @if (datafieldsConfiguration?.edit.visible) {
                <phscw-output-timestamp
                  class="cw-flex-row"
                  label="{{ 'GENERAL.ALTERATION' | translate }}"
                  [timestamp]="data.edit_date"
                additional="{{ data.edit_user }}"></phscw-output-timestamp>
              }
            </div>
          }
          @if (!timestampsVisible) {
            <span
              class="cw-link"
              (click)="toggleTimestamps()"
              >{{ 'GENERAL.SHOWTIMESTAMPS' | translate }}</span
              >
            }
          }
          <!-- Link zum Clearing -->
          @if (clearingButtonVisible && institutionId > 0 && !institutionsService.isShadow) {
            <phscw-clearing-navigation-button
              [entityType]="'institutions'"
            [entityId1]="data.id"></phscw-clearing-navigation-button>
          }
          @if (!institutionsService.isShadow) {
            <div
              class="cw-button-wrapper"
              >
              <!-- aktuell ausgeblendet bis es verallgemeinert wird-->
              @if (false) {
                <phscw-input-form-notification
                  [dataNotification]="dataNotification"
                  notification_type="institutions"
                  entity_type="institutions"
                  [entity_id]="institutionId">
                </phscw-input-form-notification>
              }
            </div>
          }
          <!-- Hinweis auf Pflichtfelder -->
          @if (editMode) {
            <div
            class="cw-horizontalline"></div>
          }
          @if (editMode) {
            <div>
              <span class="icon-asterisk cw-input-required-icon"></span>{{ 'GENERAL.REQUIREDFIELDS' | translate }}
            </div>
          }
          <!-- Buttons Submit & Cancel -->
          @if (editMode) {
            <div
              class="cw-button-wrapper">
              @if (!institutionsService.isShadow) {
                <button
                  mat-raised-button
                  color="accent"
                  type="submit"
                  [disabled]="!institutionsDataForm.form.valid || loading || saving">
                  {{ 'GENERAL.SAVE' | translate }} <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
                </button>
              }
              @if (institutionsService.isShadow) {
                <button
                  [disabled]="!institutionsDataForm.form.valid || loading || saving"
                  mat-raised-button
                  color="accent"
                  type="button"
                  (click)="clickShadowSubmit()">
                  {{ institutionId === 0 ? 'Erstellungsanfrage' : 'Änderungsanfrage' }}
                </button>
              }
              @if (institutionsService.isShadow && institutionId > 0) {
                <button
                  [disabled]="!institutionsDataForm.form.valid || loading || saving"
                  mat-raised-button
                  color="accent"
                  type="button"
                  (click)="clickShadowSubmit(true)">
                  Löschanfrage
                </button>
              }
              <button
                mat-raised-button
                color="primary"
                type="button"
                (click)="clickCancel()">
                {{ 'GENERAL.CANCEL' | translate }}
              </button>
            </div>
          }
        </form>
      }
    </div>
  } @else {
    <!--
    Wenn "data" noch nicht gesetzt ist, die card ohne Inhalt anzeigen, nur mit dem loading spinner

    Vorher wurden die Stammdaten komplett ausgeblendet, bis die Daten verfügbar waren -
    dadurch wurde alles schnell verschoben und es sah nicht sauber aus
    -->

    <div
      id="submodule-data"
      class="cw-module-card">
      <div class="cw-flex-row">
        @if (!institutionsService.isShadow) {
          <h2>{{ 'GENERAL.COREDATA' | translate }}</h2>
        }
        @if (institutionsService.isShadow) {
          <h2>Änderungsanfrage</h2>
        }
      </div>

      <div [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></div>
    </div>
  }
